import axios from "axios";

import { CartContext, CartItem, CartResult } from "custom-types/Cart";
import logError from "utils/logError";

import reservationApi, {
  ReservationsApiErrorsResponse,
} from "../services/reservations";

export const patchCartItems = async ({
  calculateTax = false,
  cartContext = null,
  cartItem,
  sessionId,
}: {
  calculateTax?: boolean;
  cartContext?: CartContext | null;
  cartItem: CartItem;
  sessionId: string;
}) => {
  try {
    const { data } = await reservationApi.patch<CartResult>(
      `/cart_items/${cartItem.id}?calculate_tax=${calculateTax}`,
      {
        cartContext: cartContext,
        cartItem: {
          quantity: cartItem.quantity,
        },
      },
      {
        headers: {
          "X-Leafly-Id": sessionId,
        },
      }
    );

    if (data?.errors) {
      throw data.errors;
    }

    return data?.data;
  } catch (e) {
    const errorData =
      axios.isAxiosError(e) &&
      (e.response?.data as ReservationsApiErrorsResponse)?.errors;

    if (errorData) {
      logError(errorData[0].detail, {
        functionName: "createOrder",
        service: "reservations",
      });

      throw errorData[0].detail;
    } else if (Array.isArray(e)) {
      logError(e[0].detail, {
        functionName: "createOrder",
        service: "reservations",
      });

      throw e[0].detail;
    } else {
      logError(e.message || "reservationUnknownError", {
        functionName: "createOrder",
        service: "reservations",
        statusCode: e.code || "UNKNOWN",
      });

      throw e;
    }
  }
};
